/**
 * Formaterar ett värde för Google-proxyns origin/destination/origins-params.
 * Rena "lat,lng" lämnas orörda; allt annat tolkas som place_id.
 */
export function toQueryValue(value: string): string {
  return /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(value) ? value : `place_id:${value}`;
}
